module.exports = __webpack_public_path__ + "img/box3_img1_active_dark.0c989c7a.png";